import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    textAlign: 'start',
    paddingLeft: theme.spacing(2)
  },
  useApplicantAddressLabel: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start'
  },
  rentersInfoTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      marginRight: theme.spacing(2)
    }
  },
  rentersInfoText: {
    fontSize: '12px',
    color: theme.colorPalette.green_100
  },
  openSidesCheckbox: {
    minHeight: 66
  },
  bannerContainer: {
    '& > div': {
      textAlign: 'left'
    }
  },
  checkboxGridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  // The dark surface InlandMarineForm's text colors are built for — mirrors the offer route's
  // `coverageCard` (risks/risk.styles.js). `textAlign` undoes the centering inherited from quote-forms.
  inlandMarineContainer: {
    background: theme.colorPalette.green_90,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners,
    textAlign: 'start',
    ...reskinStyles(theme, theme.cardStyles.outlined)
  }
}));

export default useStyles;
